import type {PublicMethodUtils} from '@wix/document-services-types'
import type {ForwardRefPublicAPI} from '@wix/document-services-public-types'
import type {PublicModuleDeclaration} from '../../documentServicesInitialisation'

export default function (publicMethodUtils: PublicMethodUtils): PublicModuleDeclaration<ForwardRefPublicAPI> {
    const {
        extensionPublicAPI: {getter, dataManipulation}
    } = publicMethodUtils

    return {
        methods: {
            components: {
                forwardRef: {
                    add: dataManipulation('forwardRef.add', {
                        getReturnValueMethodPath: 'forwardRef.getForwardRefToAddRef'
                    }),
                    getReferencedComponent: getter('forwardRef.getReferencedComponent')
                }
            }
        }
    }
}
